<script lang="ts">
	import { page } from '$app/stores'
	import Tabs from '$lib/components/Tabs.svelte'
	import { Button } from '$lib/shadcn/ui/button'
	import NodesFilter from './NodesFilter.svelte'

	export let data
</script>

<div
	class="flex flex-wrap justify-center gap-4 p-2 bg-background w-fit mx-auto mb-6 lg:sticky lg:top-0 lg:z-10 lg:pt-3"
>
	<Tabs>
		<Button
			class="lg:h-10 lg:rounded-md lg:px-6"
			variant={$page.url.pathname.includes('/scenes')
				? 'active'
				: 'ghost'}
			href="/scenes"
		>
			Scenes
		</Button>
		<Button
			class="lg:h-10 lg:rounded-md lg:px-6"
			variant={$page.url.pathname.includes('/scripts')
				? 'active'
				: 'ghost'}
			href="/scripts"
		>
			Scripts
		</Button>
		<Button
			class="lg:h-10 lg:rounded-md lg:px-6"
			variant={$page.url.pathname.includes('/collections')
				? 'active'
				: 'ghost'}
			href="/collections"
		>
			Collections
			<span
				class="rounded-full bg-primary text-[10px] text-xs text-black font-medium tracking-wide uppercase px-2 py-0.5 ml-2"
				>New</span
			>
		</Button>
	</Tabs>
	<NodesFilter disabled={$page.url.pathname.includes('/scripts')} {data} />
</div>
